import styled from 'styled-components';
import { Link, Typography } from '~/components/Atoms';
import { getThemeByPath } from '~/utils';

const spacingSmall = getThemeByPath('spacings.small');

export const LinkListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListWrapper = styled.div`
  margin-top: ${spacingSmall}px;
`;

export const Title = styled(Typography).attrs({
  variant: 'headline4',
  textColor: 'colors.secondary.main',
  typographyProps: {
    style: {
      textAlign: 'left',
    },
  },
})``;

export const LinkItem = styled(Link)``;

export const LinkItemWrapper = styled.div`
  display: flex;
  margin-top: ${spacingSmall}px;
`;
